/*************************************************/
/* COUNTER                                       */
/*************************************************/

import Velocity from 'velocity-animate';

const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

export class Counter {
    constructor(element) {
        this.statisticValueSelector = '.counter';

        if (element) {
            const rawValue = element.getAttribute('data-value');

            if (!isNaN(parseFloat(rawValue))) {
                this.animateNumber(element, parseFloat(rawValue));
            } else {
                this.animateLetters(element, rawValue);
            }
        }
    }

    animateNumber(element, targetValue) {
        const hasDecimals = targetValue % 1 !== 0;

        Velocity(element,
            { tween: [targetValue, 0] },
            {
                easing: "easeInOut",
                delay: 800,
                duration: 3000,
                progress: function (elements, complete, remaining, start, tweenValue, activeCall) {
                    const value = parseFloat(tweenValue.tween);
                    const formattedValue = hasDecimals ? value.toFixed(1) : Math.round(value);
                    element.innerHTML = formattedValue.toLocaleString();
                }
            }
        );
    }

    animateLetters(element, finalString) {
        const chars = finalString.split('');
        const animationFrames = 20; // Number of shuffles per character
        const duration = 1500; // Total animation duration
        const interval = duration / animationFrames;

        let frame = 0;
        const letterIntervals = Array(chars.length).fill(0);

        const shuffle = () => {
            let display = '';

            for (let i = 0; i < chars.length; i++) {
                if (frame < animationFrames - i * 2) {
                    // Show a random letter for now
                    display += LETTERS[Math.floor(Math.random() * LETTERS.length)];
                } else {
                    // Settle on the correct letter
                    display += chars[i];
                }
            }

            element.innerHTML = display;

            frame++;

            if (frame < animationFrames + chars.length) {
                setTimeout(shuffle, interval);
            }
        };

        setTimeout(shuffle, 800); // Delay to match number animation
    }
}

export default Counter;
